import css from './index.module.scss';
import { useState, useEffect } from 'react';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';

interface ItemProps {
    desc: string;
    img: [string, string];
    avatar: string;
    name: string;
}
export default function G() {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [gap, setGap] = useState(16);
    const items: ItemProps[] = [
        {
            desc: t('NEW2_item1_desc'),
            img: ['/responsive/picture/delta-pro-ultra/launch/24_1.jpg', '/responsive/picture/delta-pro-ultra/launch/24_1_768.jpg'],
            avatar: '/responsive/picture/delta-pro-ultra/launch/24_1_avatar.jpg',
            name: t('NEW2_item1_name'),
        },
        {
            desc: t('NEW2_item2_desc'),
            img: ['/responsive/picture/delta-pro-ultra/launch/24_2.jpg', '/responsive/picture/delta-pro-ultra/launch/24_2_768.jpg'],
            avatar: '/responsive/picture/delta-pro-ultra/launch/24_2_avatar.jpg',
            name: t('NEW2_item2_name'),
        },
        {
            desc: t('NEW2_item3_desc'),
            img: ['/responsive/picture/delta-pro-ultra/launch/24_3.jpg', '/responsive/picture/delta-pro-ultra/launch/24_3_768.jpg'],
            avatar: '/responsive/picture/delta-pro-ultra/launch/24_3_avatar.jpg',
            name: t('NEW2_item3_name'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1024 ? 24 : 16);
        }
    }, []);

    return (
        <section className={`dpu-new2 ${css['dpu-new2']}`}>
            <EfSpec />
            <h2 className="title">{t('NEW2_title')}</h2>
            <Swiper className="swiper-items" modules={[]} slidesPerView={'auto'} initialSlide={0} spaceBetween={gap}>
                {items.map((item: ItemProps, k: number) => (
                    <SwiperSlide key={k} className="item">
                        <div className="item-img">
                            <EfImg pc={item.img[0]} h5={item.img[1]} />
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
                                <g clipPath="url(#clip0_15390_31031)">
                                    <path
                                        d="M0 10.2088C0 6.17001 1.7425 2.63603 6.63 1.96289V4.44509C4.0375 5.32859 3.6125 6.38037 3.485 8.98878H6.63V14.9629H0V10.2088ZM10.37 10.2088C10.37 6.17001 12.1125 2.63603 17 1.96289V4.44509C14.4075 5.32859 13.9825 6.38037 13.855 8.98878H17V14.9629H10.37V10.2088Z"
                                        fill="white"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_15390_31031">
                                        <rect width="17" height="14" fill="white" transform="translate(0 0.962891)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                        <div className="item-info">
                            <EfImg className="item-avatar" pc={item.avatar} />
                            <div className="item-right">
                                <p className="item-name">{item.name}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
